import { FC } from 'react'
import { Navigate } from 'react-router-dom'
import { TableCard } from '../../../../../components/Table/TableCard'
import { extrairErrosProtocolo } from '../../core/errosProtocolo'
import { ModeloPlataformaListHeader } from './components/header/ModeloPlataformaListHeader'
import { useVersoesModelo } from './core/useVersoesModelo'
import { ModeloPlataformaTable } from './table/ModeloPlataformaTable'

/** Lista das versões do modelo da plataforma (T7a, área da Lauduz). */
export const ModeloPlataformaList: FC = () => {
  const { error } = useVersoesModelo()

  if (error && extrairErrosProtocolo(error).status === 403) {
    return <Navigate to='/error/404' />
  }

  return (
    <>
      <ModeloPlataformaListHeader />
      <TableCard>
        <ModeloPlataformaTable />
      </TableCard>
    </>
  )
}
